import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';
import { TimeTrackingRole } from '../../../../../../../models/time-tracking';
import { TimeTrackingService } from '../../../../../../../services/time-tracking-role/time-tracking.service';

@Component({
  selector: 'app-remove-time-tracking-role-modal',
  templateUrl: './remove-time-tracking-role-modal.component.html',
  styleUrls: ['./remove-time-tracking-role-modal.component.css']
})
export class RemoveTimeTrackingRoleModalComponent implements OnInit {

  @Input() role: TimeTrackingRole;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingRemove = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public timeTrackingRoleService: TimeTrackingService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleRemove() {
    this.loadingRemove = true;

    this.errorMessage = '';
    this.errors = {};

    this.role.is_removed = true;

    this.timeTrackingRoleService
      .updateTimeTrackingRole(this.role)
      .then(() => {
        this.savedCallback({
          text: this.role.name + ' removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove time tracking roles.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRemove = false; });
  }

}
